import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  MaterialModule } from './material.module';
import { MatMenuModule, MatIconModule } from '@angular/material';


@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        MatMenuModule,
        MatIconModule
    ],
    exports: [
        MaterialModule
    ],
    declarations: [
    ],
    providers: [
        // LoaderService,
        // {
        //     provide: HttpService,
        //     useFactory: httpServiceFactory,
        //     deps: [XHRBackend, RequestOptions, LoaderService ]
        // }
    ]
})

export class CoreModule { }
